export default "__VITE_ASSET__C7axJQTI__"